import { render, staticRenderFns } from "./MenuCartList.vue?vue&type=template&id=24584b2b&"
import script from "./MenuCartList.vue?vue&type=script&lang=ts&setup=true&"
export * from "./MenuCartList.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./MenuCartList.vue?vue&type=style&index=0&id=24584b2b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconLotPlaceholder: require('/usr/www/nuxt/components/Icon/IconLotPlaceholder.vue').default})
